import { Typography } from '@mui/material';
import { FC } from 'react';

import { InventoryProductItem } from 'types/inventory.interface';

import { ItemContainer } from './index.styled';

interface ProductProps {
  product: InventoryProductItem;
  onClick: (item: InventoryProductItem) => void;
}

const Product: FC<ProductProps> = ({ product, onClick }) => (
  <ItemContainer onClick={() => onClick(product)}>
    <Typography variant="body2" fontWeight="bold">{product.itemName}</Typography>
    <Typography variant="body2">{`$${product.priceRetailAdultUse}`}</Typography>
  </ItemContainer>
);

export default Product;
